import { render, staticRenderFns } from "./ManageChecklistProject.vue?vue&type=template&id=fbce7250"
import script from "./ManageChecklistProject.vue?vue&type=script&lang=js"
export * from "./ManageChecklistProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports